import { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MemberSidebar from './MemberSidebar';
import MemberNavbar from './MemberNavbar';
import './AppLayout.css';

function MemberLayout() {
  const location = useLocation();
  const activePage = location.pathname.split('/')[2] || 'dashboard';
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  return (
    <div className="layout">
      <MemberSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && <div className="layout__overlay" onClick={() => setSidebarOpen(false)} />}
      <div className="layout__body">
        <MemberNavbar activePage={activePage} onToggleSidebar={() => setSidebarOpen((o) => !o)} />
        <main className="layout__content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default MemberLayout;
